export default function initArchivePress() {
    const $archivePress = document.querySelector<HTMLElement>('.js-page-archive-news');

    if ($archivePress) {
        new ArchivePressPage($archivePress);
    }
}

export class ArchivePressPage {
    $container: HTMLElement;

    constructor($container: HTMLElement) {
        this.$container = $container;

        const $select = $container.querySelector<HTMLInputElement>('.js-archive-news-select');

        if ($select) {
            this.init($select);
        }
    }

    /**
     * Initialise la redirection via la valeur du select select
     * 
     * @param {HTMLInputElement} $select
     *
     * @return {void}
     */
    init($select: HTMLInputElement) {
        $select.addEventListener('change',() => {
            window.location.href = $select.value;
        });
    }
}

